import React from 'react';
import styles from '../styles/ThinkingBubble.module.css';

/**
 * Inline "(thinking...)" indicator shown as part of the conversation while
 * Sophia's reply is on its way. Replaces the old full-screen ThinkingScreen
 * takeover in the main chat (product direction): the chat stays visible and
 * the wait reads as one more line of the conversation.
 */
function ThinkingBubble() {
  return (
    <div className={styles.thinkingBubble} role="status" aria-live="polite" aria-label="Sophia is thinking">
      <span className={styles.text}>
        Thinking
        <span className={styles.dots} aria-hidden="true">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </span>
    </div>
  );
}

export default ThinkingBubble;
